import assign = require('object-assign');
import { OPEN, CLOSE } from '../constants/Modal';

import { IModalAction } from '../interfaces/actions';
import { IModalState } from '../interfaces/states';

const initialState = {
    activeModal: null,
};

export default function SaveState(state: IModalState = initialState, action: IModalAction): IModalState {
    switch (action.type) {
        case OPEN: {
            return {
                activeModal: action.target
            };
        }
        case CLOSE: {
            return {
                activeModal: null
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/modal.ts